import styled from "styled-components";
const isMobile = window.innerWidth < 768;

export const StyledAuth = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    padding-top: ${isMobile ? '60px'  : '160px' };
    background-color: rgba(251, 247, 240, 1);
`